import React from 'react';
import { Card, Toggle, RoundButton, T } from '../fields/ui';
import { SECTION_META } from '../../../utils/portalPageModel';

/*
 * SECTIONS + PRIVACY — one row per About section (toggle, label + note, ▲ ▼ order), then the two
 * privacy toggles, which are the same state as the toggles on THE BASICS and STRENGTHS + TAGS.
 */
export default function SectionsTab({ d, upd, phone }) {
  const secs = d.sections;
  const move = (i, dd) => upd((s) => {
    const a = [...s.sections];
    const j = i + dd;
    if (j < 0 || j >= a.length) return {};
    [a[i], a[j]] = [a[j], a[i]];
    return { sections: a };
  });
  const row = { display: 'flex', alignItems: 'center', gap: 12, padding: '12px 0', borderTop: '1px solid #222' };
  return (
    <>
      <Card phone={phone} data-testid="sections-card" style={{ gap: 6 }}>
        <span style={T.title}>SECTIONS</span>
        <span style={{ ...T.help, paddingBottom: 8 }}>Turn sections on or off and set their order on the About tab.</span>
        {secs.map((x, i) => (
          <div key={x.k} style={row} data-testid={`section-${x.k}`}>
            <Toggle on={x.on} onToggle={() => upd((s) => ({ sections: s.sections.map((y) => (y.k === x.k ? { ...y, on: !y.on } : y)) }))} label={`Show ${SECTION_META[x.k][0]}`} />
            <span style={{ flex: 1, minWidth: 0, display: 'flex', flexDirection: 'column', gap: 3, opacity: x.on ? 1 : 0.45 }}>
              <span style={{ fontSize: 11, fontWeight: 700, letterSpacing: '.14em' }}>{SECTION_META[x.k][0]}</span>
              <span style={{ fontSize: 11, lineHeight: 1.5, color: '#8A8A8A' }}>{SECTION_META[x.k][1]}</span>
            </span>
            <RoundButton size={32} onClick={() => move(i, -1)} dim={i === 0} aria-label={`Move ${SECTION_META[x.k][0]} up`} style={{ fontSize: 10 }}>▲</RoundButton>
            <RoundButton size={32} onClick={() => move(i, 1)} dim={i === secs.length - 1} aria-label={`Move ${SECTION_META[x.k][0]} down`} style={{ fontSize: 10 }}>▼</RoundButton>
          </div>
        ))}
      </Card>
      <Card phone={phone} data-testid="privacy-card" style={{ gap: 6 }}>
        <span style={{ ...T.title, paddingBottom: 8 }}>PRIVACY</span>
        {[
          { on: d.genderHidden, toggle: () => upd({ genderHidden: !d.genderHidden }), label: 'HIDE GENDER', note: 'Leaves gender off your page.' },
          { on: d.sensualVisible, toggle: () => upd({ sensualVisible: !d.sensualVisible }), label: 'SHOW SENSUAL & INTIMATE', note: 'Only applies if it is one of your Down For picks.' },
        ].map((x) => (
          <div key={x.label} style={row}>
            <Toggle on={x.on} onToggle={x.toggle} label={x.label} />
            <span style={{ flex: 1, minWidth: 0, display: 'flex', flexDirection: 'column', gap: 3 }}>
              <span style={{ fontSize: 11, fontWeight: 700, letterSpacing: '.14em' }}>{x.label}</span>
              <span style={{ fontSize: 11, lineHeight: 1.5, color: '#8A8A8A' }}>{x.note}</span>
            </span>
          </div>
        ))}
      </Card>
    </>
  );
}
